/*
 * Preview do bordado sobre a foto calibrada — ADR-0017.
 *
 * Desenho e carga de foto compartilhados entre a PDP (`bordado-pdp.js`) e o
 * modal da grade de kit (`kit-builder.js`): as duas telas seguem exatamente as
 * mesmas regras, porque o cliente confia no que vê e bordado não tem troca.
 *
 * Não guarda estado de componente. Quem chama entrega o canvas, a foto já
 * carregada e o que o cliente digitou.
 *
 * Depende de `bordado-geometria.js` e `bordado-render.js`, carregados antes.
 */

(function (window) {
  'use strict';

  /** Fotos já baixadas, por URL: reabrir o modal não baixa de novo. */
  const fotos = new Map();

  /**
   * Carrega a foto, uma vez só por URL.
   *
   * `crossOrigin` anônimo porque o canvas lê a imagem do CDN da Shopify. Falha
   * não fica em cache: uma queda de rede não pode travar a foto até recarregar.
   *
   * @param {string} url
   * @returns {Promise<HTMLImageElement>}
   */
  function carregarFoto(url) {
    if (fotos.has(url)) return fotos.get(url);

    const promessa = new Promise((resolver, rejeitar) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => resolver(img);
      img.onerror = rejeitar;
      img.src = url;
    });

    fotos.set(url, promessa);
    promessa.catch(() => fotos.delete(url));

    return promessa;
  }

  /**
   * Repinta foto e texto no canvas. Chamado a cada tecla.
   *
   * @param {HTMLCanvasElement} canvas
   * @param {{foto: HTMLImageElement, calibragem: object, lado: string, campos: string[], cor: string, familia: string}} opcoes
   *   `campos` na ordem do contrato do app; `cor` é o hex do swatch.
   * @returns {{estourou: boolean}}
   */
  function desenhar(canvas, { foto, calibragem, lado, campos, cor, familia }) {
    canvas.width = foto.naturalWidth;
    canvas.height = foto.naturalHeight;

    const ctx = canvas.getContext('2d');
    ctx.drawImage(foto, 0, 0);

    const g = window.FoxTheme.bordadoGeometria;
    const area = g.areaDoLado(calibragem, lado);
    const p = g.areaEmPixels(area, canvas.width, canvas.height);

    // Cada campo do app é um bloco com o próprio corpo: o nome em `corpo`, a
    // especialidade em `linha`. Medir com o tamanho do bloco, não com um só.
    const medir = (texto, tamanho) => {
      ctx.font = `${tamanho}px "${familia}"`;
      return ctx.measureText(texto).width;
    };
    const { blocos } = g.montarBlocos(campos, p, medir);
    const saida = window.FoxTheme.bordadoRender.desenhar(ctx, {
      area, largura: canvas.width, altura: canvas.height, blocos, cor, familia,
    });

    return { estourou: saida.estourou };
  }

  window.FoxTheme = window.FoxTheme || {};
  window.FoxTheme.bordadoPreview = { carregarFoto, desenhar };
})(window);
